module.exports = __webpack_public_path__ + "static/img/大雨.290b5058.svg";